import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { billingAddressStyles } from "@insite/content-library/Widgets/CheckoutShipping/BillingAddress";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

billingAddressStyles.headingGridItem = mergeToNew(billingAddressStyles.headingGridItem, {
    css: css`
        /* background: ${getColor("info.contrast")}; */
        background: ${getColor("common.backgroundContrast")};
        padding: 15px 18px;
    `,
});

billingAddressStyles.selectSavedAddressLink = {
    css: css`
        margin-left: auto;
    `,
};

billingAddressStyles.addressBookModalCancelButton = {
    variant: "secondary",
    hoverMode: "none",
    css: css`
        background: ${getColor("primary.contrast")};
        color: ${getColor("text.accent")};
        border: 2px solid ${getColor("text.accent")};
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:disabled {
            background: ${getColor("primary.contrast")} !important;
            span[class^="TypographyStyle"] {
                color: ${getColor("text.main")};
                font-size: 14px;
                line-height: ${TYPOGRAPHY.lineHeight.base};
            }
            opacity: 0.5;
        }
        &:hover {
            /* background: ${getColor("text.accent")}; */
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            opacity: 0.3;
            background: none !important;

            /* span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
           
        } */
        }
    `,
};
